import { useMutation, useQuery } from 'react-query'

import { useAppSelector } from 'app/state'

import { defaultBranding } from 'features/common/ui/theme/cartoTheme'
import useBrandingQueries from 'features/branding/api/brandingQueries'
import useUserPermissions from 'features/account/state/useUserPermissions'

import cartoLogoDot from 'assets/img/carto-logo-dot.svg'

export function useBranding(hasCustomLogo?: boolean) {
  const mapBranding = useAppSelector((state) => state.maps.currentMap?.branding)
  const { queries } = useBrandingQueries()
  const { enterpriseBrandingAvailable } = useUserPermissions()
  const queryResult = useQuery({ ...queries.getBranding, enabled: Boolean(enterpriseBrandingAvailable) })

  return {
    ...queryResult,
    data: mapBranding || {
      ...defaultBranding,
      logoUrl: hasCustomLogo ? undefined : defaultBranding.logoUrl,
      ...queryResult.data
    }
  }
}

export function useSaveBranding(optimistic = false) {
  const { queries } = useBrandingQueries()
  const saveBrandingMutation = useMutation(optimistic ? queries.saveBranding : queries.saveBrandingOptimistic)

  return saveBrandingMutation
}

export function useSaveBrandingLogo() {
  const { queries } = useBrandingQueries()
  const saveBrandingLogoMutation = useMutation(queries.saveBrandingLogo)

  return saveBrandingLogoMutation
}

export function useDeleteBranding() {
  const { queries } = useBrandingQueries()
  const deleteBrandingMutation = useMutation(queries.deleteBranding)

  return deleteBrandingMutation
}

export function useBrandingLogo(logo?: string) {
  const mapBranding = useAppSelector((state) => state.maps.currentMap?.branding)
  const cartoLogo = logo || cartoLogoDot
  const hasCustomLogo = logo !== undefined
  const { data: branding } = useBranding(hasCustomLogo)

  return mapBranding?.logoUrl || branding?.logoUrl || cartoLogo
}
